"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleCounter = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.CircleCounter = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 80px;\n  height: 80px;\n  border-radius: 40px;\n  text-align: center;\n"], ["\n  width: 80px;\n  height: 80px;\n  border-radius: 40px;\n  text-align: center;\n"])));
var templateObject_1;
